
import React from 'react';
import { Card } from '@/components/ui/card';
import { Mail, Phone, Building, GraduationCap, CalendarDays, MapPin, User, Briefcase } from 'lucide-react';
import { Teacher } from '@/types/teacher.types';

interface TeacherProfileCardProps {
  teacher: Teacher;
}

export const TeacherProfileCard = ({ teacher }: TeacherProfileCardProps) => {
  // Improved helper function to get department display name
  const getDepartment = () => {
    if (teacher.department) return teacher.department;
    if (teacher.departments && teacher.departments.length > 0) {
      return typeof teacher.departments[0] === 'string' ? 
        teacher.departments[0] : 
        teacher.departments[0]?.name || 'Not Assigned';
    }
    return 'Not Assigned';
  };

  return (
    <Card className="p-6 col-span-1">
      <div className="flex flex-col items-center">
        {teacher.profileImage ? (
          <img 
            src={teacher.profileImage} 
            alt={`${teacher.firstName} ${teacher.lastName}`}
            className="w-32 h-32 rounded-full object-cover mb-4"
          />
        ) : (
          <div className="w-32 h-32 rounded-full bg-primary/10 flex items-center justify-center mb-4">
            <span className="text-3xl font-bold text-primary">
              {teacher.firstName?.[0]}{teacher.lastName?.[0]}
            </span>
          </div>
        )}
        <h2 className="text-2xl font-bold text-center">{teacher.firstName} {teacher.lastName}</h2>
        <p className="text-primary font-medium">{getDepartment()}</p>
        <p className="text-gray-500">{teacher.position}</p>
      </div>

      <div className="mt-6 space-y-3">
        <div className="flex items-center">
          <Mail className="w-5 h-5 text-gray-500 mr-3" />
          <span>{teacher.email || 'No email provided'}</span>
        </div>
        <div className="flex items-center">
          <Phone className="w-5 h-5 text-gray-500 mr-3" />
          <span>{teacher.phone || 'No phone provided'}</span>
        </div>
        <div className="flex items-center">
          <Building className="w-5 h-5 text-gray-500 mr-3" />
          <span>{getDepartment()}</span>
        </div>
        <div className="flex items-center">
          <GraduationCap className="w-5 h-5 text-gray-500 mr-3" />
          <span>{teacher.qualifications?.[0]?.degree || 'No qualification provided'}</span>
        </div>
        <div className="flex items-center">
          <CalendarDays className="w-5 h-5 text-gray-500 mr-3" />
          <span>Joined: {teacher.joinDate ? new Date(teacher.joinDate).toLocaleDateString() : 'No join date'}</span>
        </div>
        <div className="flex items-center">
          <MapPin className="w-5 h-5 text-gray-500 mr-3" />
          <span>{teacher.address ? `${teacher.city}, ${teacher.country}` : 'No address provided'}</span>
        </div>
        <div className="flex items-center">
          <User className="w-5 h-5 text-gray-500 mr-3" />
          <span>Father's Name: {teacher.fatherName || 'Not provided'}</span>
        </div>
        <div className="flex items-center">
          <Briefcase className="w-5 h-5 text-gray-500 mr-3" />
          <span>ID: {teacher.idNumber || 'Not provided'}</span>
        </div>
      </div>
    </Card>
  );
};
